import gql from "graphql-tag";
import { contactDetailsFields } from "../queries/getContactDetails";

export const ADD_CONTACT_PAYMENT_METHOD = gql`mutation addContactPaymentMethod($contactId: ID!, $paymentMethodId: ID!) {
    addContactPaymentMethod(contactId: $contactId, paymentMethodId: $paymentMethodId) {
        ${contactDetailsFields}
    }
}`;
